import API from "../services/api";
import StorageService from '../services/general/storage';
import CollectionsService from '../services/general/collections';
import moment from 'moment'; 
const attribute = "workorderitems";
const uuidv1 = require('uuid/v1');  
const Service = {
    createNewOrderItem: (userID, workorderGUID, project, date) => {
        return new Promise((resolve, reject) => {
            let orderItem = {};
            orderItem.workorderguid = workorderGUID;
            orderItem.status = 0;
            orderItem.user = userID;
            orderItem.guid = userID + '-' + uuidv1();
            orderItem.created = new Date();
            orderItem.date = date || new Date();
            orderItem.kilometers = 0;
            orderItem.minutes = 0;
            orderItem.minutesovertime = 0;
            orderItem.location = 0;
            orderItem.nights = 0;
            orderItem.travelhours = 0;
            orderItem.project = project;
            orderItem.signature = '';
            orderItem.setkm = project.client.setkm;
            orderItem.setnights = project.client.setnights;
            orderItem.setautograph = project.client.setautograph;
            orderItem.settravelhours = project.client.settravelhours;
            orderItem.setpurchasenr = project.client.setpurchasenr;
            orderItem.setraceminutes = project.client.setraceminutes;
            orderItem.attachments = [];
            orderItem.active=true;
            Service.save(orderItem, true)
                .then(result => {
                  resolve(result);
                
                })
                .catch(err => {
                    resolve(orderItem);
                })
        })
    },
    get: guid => {
        return new Promise((resolve, reject) => {
            API.get(guid ? attribute + "/" + guid : attribute).then(
                result => {
                    //check storage
                    StorageService.getCollectionObject(attribute, guid).then(
                        (foundStorage) => {
                            let compared = CollectionsService.combineByModifiedDate(result, foundStorage);
                            resolve(compared)
                        },
                        (err) => {
                            resolve(result)
                        }
                    )
                },
                error => {
                    StorageService.getCollectionObject(attribute, guid)
                        .then((foundStorage) => {
                            resolve(foundStorage);
                        }, (err) => {
                            reject(err);
                        })
                }
            );
        });
    },
    getByOrderGUID: (guid, userid) => {
        return new Promise((resolve, reject) => {
            API.get(attribute + "/workorder/" + guid + '/user/' + userid).then(
                result => {
                    //check storage
                    StorageService.getCollectionObject(attribute)
                        .then(
                            (storageItems) => {
                                let foundStorage = storageItems.filter((item) => { return (item.workorderguid === guid && item.user === userid) });
                                let combined = CollectionsService.combineByModifiedDate(result, foundStorage);
                                resolve(combined)
                            }, (err) => {
                                resolve(result)
                            })
                },
                error => {
                    StorageService.getCollectionObject(attribute)
                        .then(
                            (storageItems) => {
                                let foundStorage = storageItems.filter((item) => { return (item.workorderguid === guid) });

                                resolve(foundStorage)
                            }, (err) => {
                                reject(err);
                            })
                }
            );
        });
    },
    save: (item, saveLocal) => {
        item.lastmodified = new Date();
        if (item.status === 0) {
            if (saveLocal) Service.localSave(item);
        } else {
            StorageService.deleteCollectionObject(attribute, item.guid);
        }


        return new Promise((resolve, reject) => {
            if (item._id) {
                API.post(attribute + "/" + item.guid, [], item).then(
                    result => {
                        resolve(result);
                    },
                    error => {
                        reject(error);
                    }
                );
            } else {
                API.put(attribute, [], item).then(
                    result => {
                        resolve(result);
                    },
                    error => {
                        reject(error);
                    }
                );
            }
        });
    },
    saveItems: (items, saveLocal) => {
        return new Promise((resolve, reject) => {
            let tasks = [];
            if (items) {
                items.forEach(item => {
                    tasks.push(Service.save(item, saveLocal));
                });
            }
            Promise.all(tasks)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })

        });
    },
    localSave: (item) => {
        return new Promise((resolve, reject) => {
            StorageService.setCollectionObject(attribute, item.guid, item);
            resolve();
        });
    },
    delete: item => {
        return new Promise((resolve, reject) => {
            StorageService.deleteCollectionObject(attribute, item.guid);
            if (item._id) {
                API.deleteItem(attribute + "/" + item._id).then(
                    result => {
                        resolve(result);
                    },
                    error => {
                        reject(error);
                    }
                );
            }else{
                resolve();
            }
        });
    },
    deleteItems: (items) => {
        return new Promise((resolve, reject) => {
            let tasks = [];
            if (items) {
                items.forEach(item => {
                    tasks.push(Service.delete(item));
                });
            }
            Promise.all(tasks)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                })

        });
    },
    getByProjectID: (projectID) => {
        return new Promise((resolve, reject) => {
            API.get(attribute + '/project/' + projectID).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    getHolidayForUser: (userID) => {
        return new Promise((resolve, reject) => {
            API.get(attribute + '/holiday/' + userID).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    getDoctersForUser: (userID) => {
        return new Promise((resolve, reject) => {
            API.get(attribute + '/docters/' + userID).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    getBabiesForUser: (userID) => {
        return new Promise((resolve, reject) => {
            API.get(attribute + '/babies/' + userID).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    getUniqueDays: (items, order) => {
        let secondsinDay = 24 * 60 * 60 * 1000;
        let uniqueDays = [];
        function compare(a, b) {
            if (a.date > b.date) return 1;
            if (b.date > a.date) return -1;
            return 0;
        }
        let sortedItems = items.sort(compare);

        let firstDay;
      
        //added 22 sept 2020
        if (sortedItems.length > 0) {
            firstDay = new Date(sortedItems[0].date);
        } else {
            firstDay = new Date(order.created);
        }

        let offset = firstDay.getDay();
        firstDay = new Date(firstDay.getTime() - ((offset) * secondsinDay))

        for (let i = 0; i < 7; i++) {
            uniqueDays.push(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate()));
            firstDay = new Date(firstDay.getTime() + secondsinDay)
        }

        sortedItems.forEach(item => {
            let dt = new Date(item.date);
            let day = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
            let found = uniqueDays.filter(item => { return (item.toString() === day.toString()) })

            if (found.length === 0) {
                uniqueDays.push(day);
            }
        })
      
        return uniqueDays;
    },
    getTotals: (items, uniqueDay) => {
        let totalMinutes = 0;
        let totalMinutesovertime = 0;
        let totalRaceMinutes = 0;
        let totalKilometers = 0;
        let totalNights = 0;
        let totalTravelhours = 0;
        items.forEach((item) => {
            if (uniqueDay) {
                let dayPrep = new Date(item.date);
                let day = new Date(dayPrep.getFullYear(), dayPrep.getMonth(), dayPrep.getDate());
                let uniqueDayPrep = new Date(uniqueDay);

                if (day.toDateString() === uniqueDayPrep.toDateString()) {
                    totalMinutes += parseInt(item.minutes);
                    totalMinutesovertime += parseInt(item.minutesovertime);
                    if (isNaN(item.kilometers || 0) === false) { totalKilometers += parseFloat(item.kilometers || 0) };
                    if (isNaN(item.nights || 0) === false) { totalNights += parseInt(item.nights || 0) };
                    if (isNaN(item.travelhours || 0) === false) { totalTravelhours += parseFloat(item.travelhours || 0) };
                    if (isNaN(item.raceminutes || 0) === false) { totalRaceMinutes += parseInt(item.raceminutes || 0) };

                }
            } else {
                totalMinutes += parseInt(item.minutes);
                totalMinutesovertime += parseInt(item.minutesovertime);
                if (isNaN(item.kilometers || 0) === false) { totalKilometers += parseFloat(item.kilometers || 0) };
                if (isNaN(item.nights || 0) === false) { totalNights += parseInt(item.nights || 0) };
                if (isNaN(item.travelhours || 0) === false) { totalTravelhours += parseFloat(item.travelhours || 0) };
                if (isNaN(item.raceminutes || 0) === false) { totalRaceMinutes += parseInt(item.raceminutes || 0) };
            }

        })
        totalMinutes = Math.round(((totalMinutes / 60)) * 100, 2) / 100;
        totalMinutesovertime = Math.round(((totalMinutesovertime / 60)) * 100, 2) / 100;
        totalRaceMinutes = Math.round(((totalRaceMinutes / 60)) * 100, 2) / 100;

        let retString = '';
        if (!isNaN(totalMinutes)) {
            if (totalMinutes !== 0) {
                retString += totalMinutes + ' uren';
            }
        }
        if (!isNaN(totalMinutesovertime)) {
            if (totalMinutesovertime !== 0) {
                if (retString.length > 0) { retString += ' / ' }
                retString += totalMinutesovertime + ' overuren';
            }
        }
        if (!isNaN(totalRaceMinutes)) {
            if (totalRaceMinutes !== 0) {
                if (retString.length > 0) { retString += ' / ' }
                retString += totalRaceMinutes + ' gasgeven';
            }
        }
        if (!isNaN(totalKilometers)) {
            if (totalKilometers !== 0) {
                if (retString.length > 0) { retString += ' / ' }
                retString += totalKilometers + ' km.';
            }
        }
        if (!isNaN(totalNights)) {
            if (totalNights !== 0) {
                if (retString.length > 0) { retString += ' / ' }
                retString += totalNights + ' overnachtingen';
            }
        }
        if (!isNaN(totalTravelhours)) {
            if (totalTravelhours !== 0) {
                if (retString.length > 0) { retString += ' / ' }
                retString += totalTravelhours + ' reisuren';
            }
        }
        return retString;
    },
    calculateTotals: (orderItems) => {
        let tmpTotalKM = 0;
        let tmpTotalKMHours = 0;
        let tmpTotalNights = 0;
        let tmpTotalMinutesSunday = 0;
        let tmpTotalMinutesSaterday = 0;
        let tmpTotalMinutes = 0;
        let tmpTotalMinutesOvertime = 0;
        let tmpTotalMinutesLocationSunday = 0;
        let tmpTotalMinutesLocationSaterday = 0;
        let tmpTotalMinutesLocation = 0;
        let tmpTotalMinutesLocationOvertime = 0;
        let tmpTotalRaceMinutes = 0;
        orderItems.forEach(item => {
            if (item.checked) {


                let weekDay = moment(item.date).isoWeekday(); // 7 = zondag , 6 = zaterdag
                tmpTotalKM = (tmpTotalKM + (item.kilometers || 0));
                tmpTotalKMHours = (tmpTotalKMHours + (item.travelhours || 0));
                tmpTotalNights = (tmpTotalNights + (item.nights || 0));

                item.minutes = parseFloat(item.minutes || 0);
                item.minutesovertime = parseFloat(item.minutesovertime || 0);

                if (item.location === 1 || item.location === 0 || !item.location) {//werkplaats
                    if (weekDay === 7) { // 7 = zondag
                        tmpTotalMinutesSunday = (tmpTotalMinutesSunday + item.minutes + item.minutesovertime);
                    } else if (weekDay === 6) { // 6 = zaterdag

                        tmpTotalMinutesSaterday = (tmpTotalMinutesSaterday + item.minutes + item.minutesovertime);
                    } else {
                        tmpTotalMinutes = (tmpTotalMinutes + item.minutes);
                        tmpTotalMinutesOvertime = (tmpTotalMinutesOvertime + item.minutesovertime);
                    }
                } else if (item.location === 2) {//locatie
                    if (weekDay === 7) { // 7 = zondag
                        tmpTotalMinutesLocationSunday = (tmpTotalMinutesLocationSunday + item.minutes + item.minutesovertime);
                    } else if (weekDay === 6) { // 6 = zaterdag
                        tmpTotalMinutesLocationSaterday = (tmpTotalMinutesLocationSaterday + item.minutes + item.minutesovertime);
                    } else {
                        tmpTotalMinutesLocation = (tmpTotalMinutesLocation + item.minutes);
                        tmpTotalMinutesLocationOvertime = (tmpTotalMinutesLocationOvertime + item.minutesovertime);
                    }
                }

                tmpTotalRaceMinutes = tmpTotalRaceMinutes + parseFloat(item.raceminutes || 0);
            }
        })
        let retValue = { totalKM: tmpTotalKM, totalKMHours: tmpTotalKMHours, totalNights: tmpTotalNights, totalMinutesSunday: tmpTotalMinutesSunday, totalMinutesSaterday: tmpTotalMinutesSaterday, totalMinutes: tmpTotalMinutes, totalMinutesOvertime: tmpTotalMinutesOvertime, totalMinutesLocationSunday: tmpTotalMinutesLocationSunday, totalMinutesLocationSaterday: tmpTotalMinutesLocationSaterday, totalMinutesLocation: tmpTotalMinutesLocation, totalMinutesLocationOvertime: tmpTotalMinutesLocationOvertime, totalRaceMinutes: tmpTotalRaceMinutes };
        return retValue;
    },
    calculateTotalUsers: (orderItems) => {
        let users = [];
        //filter unique users
        for (let i = 0; i < orderItems.length; i++) {
            if (!users.find((item) => { return item._id === orderItems[i].user._id }) && orderItems[i].checked) {
                users.push(orderItems[i].user)
            }
        }
        //calculating totals
        for (let i = 0; i < users.length; i++) {
            users[i].fullName = users[i].firstname + ' ' + users[i].lastname;
            let orderItemsUser = orderItems.filter((item) => { return (item.user._id === users[i]._id && item.checked) })
            users[i].totalKilometers = Service.calculateTotalAttribute(orderItemsUser, 'kilometers');
            users[i].totalTravelHours = Service.calculateTotalAttribute(orderItemsUser, 'travelhours');
            users[i].totalNights = Service.calculateTotalAttribute(orderItemsUser, 'nights');
            users[i].totalWorkplace = Service.calculateTotalAttribute(orderItemsUser, 'minutes', 1);
            users[i].totalOverhoursWorkplace = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 1, [1, 2, 3, 4, 5]);
            users[i].totalOverhoursWorkplaceSaturday = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 1, [6]);
            users[i].totalOverhoursWorkplaceSunday = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 1, [7]);
            users[i].totalLocation = Service.calculateTotalAttribute(orderItemsUser, 'minutes', 2);
            users[i].totalOverhoursLocation = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 2, [1, 2, 3, 4, 5]);
            users[i].totalOverhoursLocationSaturday = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 2, [6]);
            users[i].totalOverhoursLocationSunday = Service.calculateTotalAttribute(orderItemsUser, 'minutesovertime', 2, [7]);
            users[i].totalRaceMinutes = Service.calculateTotalAttribute(orderItemsUser, 'raceminutes');

            users[i].postFix = '';
            switch (users[i].type) {
                case 1:
                    users[i].postFix = '_per'
                    break;
                case 2:
                    users[i].postFix = '_uit'
                    break;
                case 3:
                    users[i].postFix = '_zzp'
                    break;
                default:
                    break;
            }
        }


        return users;
    },
    calculateTotalAttribute: (orderItems, attribute, location, weekDays) => {

        let retValue = 0;
        for (let i = 0; i < orderItems.length; i++) {
            if (!isNaN(orderItems[i][attribute])) {
                let useItem = false;
                if (location) {
                    if (orderItems[i].location === location) {
                        useItem = true;
                    }
                } else {
                    useItem = true;
                }
                if (weekDays) {
                    let orderItemWeekDay = moment(orderItems[i].date).isoWeekday(); // 7 = zondag , 6 = zaterdag

                    if (weekDays.indexOf(orderItemWeekDay) === -1) {
                        useItem = false;
                    }
                }

                if (useItem) {
                    retValue += parseFloat(orderItems[i][attribute]);
                }
            }
        }

        return retValue;
    },
    getWeekNumbers: (orderItems) => {
        let weeknrs = [];
        for (let i = 0; i < orderItems.length; i++) {
            let weeknr = moment(orderItems[i].date).format('w');
            if (weeknrs.indexOf(weeknr) === -1) {
                weeknrs.push(weeknr);
            }
        }
        return weeknrs;
    }
};

export default Service;
